import type { RouteRecordRaw } from 'vue-router';

import { computed } from 'vue';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    name: 'billing',
    path: 'billing',
    component: () => import('../BillingIndex.vue'),
    meta: {
      permissions: ['ADMIN'],
      title: computed(() => t('messages.billing')),
    },
  },
];
